import { render, staticRenderFns } from "./btActivityTemplate.vue?vue&type=template&id=327bbfbe"
import script from "./btActivityTemplate.vue?vue&type=script&lang=js"
export * from "./btActivityTemplate.vue?vue&type=script&lang=js"
import style0 from "./btActivityTemplate.vue?vue&type=style&index=0&id=327bbfbe&prod&lang=scss"
import style1 from "./btActivityTemplate.vue?vue&type=style&index=1&id=327bbfbe&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports